// export const customStyles = {
//     statusFilter: {
//         container: (provided) => ({
//             display: "inline-block",
//             position: "relative",
//             width: "100%",
//             fontSize: "1rem",
//             ...provided
//         }),
//         control: (provided, state) => ({
//             ...provided,
//             minHeight: "40px",
//             borderColor: "#0f984f",
//             boxShadow: state.isFocused ? 0 : 0,
//             borderRadius: "10px",
//             fontSize: "1rem",
//             "&:hover": {
//                 borderWidth: "2px",
//                 borderColor: "#0f984f"
//             }
//         }),
//         option: (provided, state) => ({
//             ...provided,
//             fontWeight: 500,
//             color: state.isSelected ? "#fff" : "#0f984f",
//             background: state.isSelected ? "#fff" : "#fff",
//             fontSize: "1rem",
//             fontFamily: "PublicSans",
//             textAlign: "center",
//             "&:hover": {
//                 color: "#fff",
//                 background: "linear-gradient(185.12deg, #4bee8d -74.08%, #14c667 73.64%) !important"
//             }
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             textAlign: "left",
//             width: "100%",
//             fontSize: "1rem !important"
//         }),
//         singleValue: (provided) => ({
//             ...provided,
//             textAlign: "left",
//             width: "100%",
//             fontSize: "1rem" // Ensures single selected value remains centered
//         }),
//         input: (provided) => ({
//             ...provided,
//             textAlign: "left",
//             fontSize: "1rem"
//         })
//     }
// };

export const customStyles = {
    statusFilter: {
        container: (provided) => ({
            display: "inline-block",
            position: "relative",
            width: "100%",
            minHeight: "45px",
            ...provided
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: "45px",
            borderColor: "#DCE0E4",
            boxShadow: state.isFocused ? 0 : 0,
            boxShadow: "0px 1px 4px #8b8a8a29",
            borderRadius: "1px",
            "&:hover": {
                borderWidth: "1px",
                borderColor: "#DCE0E4"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontWeight: 500,
            color: state.isSelected ? "#fff" : "#CC9C58",
            background: state.isSelected ? "#CC9C58" : "#fff",
            fontSize: "1rem",
            fontFamily: "PublicSans",
            textAlign: "center",
            "&:hover": {
                color: "#fff",
                background: "#e2b97d"
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            textAlign: "left",
            width: "100%",
            fontSize: "1rem",
            color: "#a5a6a7"
        }),
        singleValue: (provided) => ({
            ...provided,
            textAlign: "left",
            fontSize: "1rem",
            color: "#48494A",
            width: "100%" // Ensures single selected value remains centered
        }),
        input: (provided) => ({
            ...provided,
            textAlign: "left",
            fontSize: "1rem"
        })
    }
};
